export const pageTitleGenerator = (collection = null, category = null, snippet = null, defaultTitle = '') => {
    let base = '';

    if (collection) {
        base = collection.name;

        if (category && category.id !== collection.id) {
            base += ` \\ ${category.name}`;
        }
    } else if (category) {
        base = category.name;
    }

    if (snippet) {
        if (base !== '') {
            base = ` - ${base}`;
        }

        base = `${snippet.title}${base}`;
    }

    return base || defaultTitle;
};

export const publicPageTitleGenerator = (collection = null, category = null, snippet = null, defaultTitle = '') => {
    let publicSuffix = ' - Public ';
    if (collection) { publicSuffix += 'collections' }
    else if (category) { publicSuffix += 'lists' }
    else { publicSuffix += 'snippets' }

    return pageTitleGenerator(collection, category, snippet, defaultTitle) + publicSuffix;
};

export const urlGenerator = (collection_id = null, category_id = null, snippet_id = null) => {
    let base = '/';

    if (collection_id !== null) {
        base += `collections/${collection_id}`;
    } else {
        base += 'lists'
    }

    if (category_id !== null) {
        base += `/${category_id}`;
    }

    if (snippet_id !== null) {
        base += `/${snippet_id}`;
    }

    return base;
};

export const publicUrlGenerator = (collection_id = null, category_id = null, snippet_id = null) => {
    let base = '/public';

    if (collection_id) {
        base += '/collections';
    } else if (category_id) {
        base += '/lists';
    } else {
        base += '/snippets';
    }

    if (collection_id) {
        base += `/${collection_id}`;
    }
    if (category_id) {
        base += `/${category_id}`;
    }
    if (snippet_id) {
        base += `/${snippet_id}`;
    }

    return base;
};

export const getPermaLink = (snippet) => {
    const isPublic = (
        snippet.visibility === 'public'
        || (snippet.Category && (
            snippet.Category.visibility === 'public'
            || (snippet.Category.Parent && snippet.Category.Parent.visibility === 'public')
        ))
    );

    if (isPublic) {
        const { Category: category } = snippet;
        const collectionId = category && (
            category.is_collection
                ? category.id
                : (category.Parent && category.Parent.id)
        );

        return publicUrlGenerator(collectionId, category && category.id, snippet.id);
    } else {
        return null;
    }
};
